import React, { useEffect, useState } from 'react';
import Pagination from '../util/pagination/Pagination';
import { Link } from 'react-router-dom';
import TableTemplate from '../util/tabletemplate/TableTemplate';
import Modal from '../util/modal/Modal';
import SustitutosInsumosAPI from '../../services/SustitutosInsumos';
import { toast } from 'react-toastify';
import ErrorMessages from '../../util/validation-error-messages';
import Loading from '../util/loading/Loading';
import AcceptModal from '../util/acceptModal/AcceptModal';

export const SustitutosInsumos = () => {

  const [state, setState] = useState({
    listaDrives: [],
    driveSeleccionado: null,
    modalEditar: false,
    confirmModal: false,
    isLoading: false
  })

  useEffect(() => {
    window.scrollTo(0, 0);
    setState({ ...state, isLoading: true })
    let listaDrivesAux = []
    SustitutosInsumosAPI.GetDrives()
      .then(res => {
        listaDrivesAux = res.data
        setState({ ...state, listaDrives: listaDrivesAux })
      }).catch(err => {
        setState({ ...state, isLoading: false })
        if (err.response) {
          toast.error(err.response.data.Message)
        } else {
          toast.error(ErrorMessages.SinConexion)
        }
      })

  }, [])

  const GetSustitutosDrives = (drive) => {
    setState({ ...state, isLoading: true })
    SustitutosInsumosAPI.GetSustitutos(drive.IdCaffenio)
      .then(res => {
        drive.ListaSustitutos = res.data
        setState({ ...state, driveSeleccionado: drive, modalEditar: true, isLoading: false })
      }).catch(err => {
        setState({ ...state, isLoading: false })
        if (err.response) {
          toast.error(err.response.data.Message)
        } else {
          toast.error(ErrorMessages.SinConexion)
        }
      })
  }

  const DeleteSustituto = (sustituto) => {
    setState({ ...state, isLoading: true })
    SustitutosInsumosAPI.DeleteSustituto(sustituto)
      .then(res => {
        let driveSeleccionadoAux = { ...state.driveSeleccionado }
        let indexAux = driveSeleccionadoAux.ListaSustitutos.findIndex((x) => x === sustituto)
        driveSeleccionadoAux.ListaSustitutos.splice(indexAux, 1)
        setState({ ...state, driveSeleccionado: driveSeleccionadoAux, isLoading: false })
        toast.success('El sustituto fue eliminado correctamente')
      }).catch(err => {
        setState({ ...state, isLoading: false })
        if (err.response) {
          toast.error(err.response.data.Message)
        } else {
          toast.error(ErrorMessages.SinConexion)
        }
      })
  }

  const DeleteSustitutoDrive = (sustituto) => {
    setState({ ...state, isLoading: true })
    SustitutosInsumosAPI.DeleteSustituto(sustituto)
      .then(res => {
        let listaDrivesAux = [...state.listaDrives]
        let indexAux = listaDrivesAux.findIndex((x) => x.IdCaffenio === state.driveSeleccionado.IdCaffenio)
        listaDrivesAux.splice(indexAux, 1)
        setState({ ...state, listaDrives:listaDrivesAux , driveSeleccionado: null, isLoading: false, confirmModal: false })
        toast.success('Los sustitutos del drive fueron eliminados correctamente')
      }).catch(err => {
        setState({ ...state, isLoading: false })
        if (err.response) {
          toast.error(err.response.data.Message)
        } else {
          toast.error(ErrorMessages.SinConexion)
        }
      })
  }

  return (
    <div>
      <h1 className='title is-2'>Sustitutos de insumos</h1>

      <div className="field">
        <div className="control has-text-right">
          <Link
            to='/sustitutosInsumos/nuevo'
            className='button is-success'
          >
            <span className="icon is-small">
              <i className="fa fa-plus"></i>
            </span>
            <span>Nuevo sustituto</span>
          </Link>
        </div>
      </div>

      <div className='card'>
        <div className='card-content'>
          <TableTemplate
            columns={["IdCaffenio", "Caffenio"]}
            columnsNames={["ID", "Drive"]}
            data={state.listaDrives}
            canEdit
            edit={(drive) => GetSustitutosDrives(drive)}
            canDelete
            remove={(drive) => setState({ ...state, confirmModal: true, driveSeleccionado: drive })}
          />

        </div>
      </div>

      {state.modalEditar && <Modal
        showModal={true}
        modalTitle={`Sustitutos de ${state.driveSeleccionado.Caffenio}`}
        width='50%'
        cancel={() => setState({ ...state, modalEditar: false })}
      >
        <TableTemplate
          columns={["IdSustitutoViejo", "SustitutoViejo", "IdSustitutoNuevo", "SustitutoNuevo"]}
          columnsNames={["ID", "Insumo Viejo", "ID ", "Insumo Nuevo"]}
          data={state.driveSeleccionado.ListaSustitutos}
          canDelete
          remove={(sustituto) => DeleteSustituto(sustituto)}
        />
      </Modal>}

      <Loading isFullscreen={true} isLoading={state.isLoading} width='100px' height='100px' />

      <AcceptModal
        modalTitle="Eliminar sustitutos"
        modalBody={<p>{`¿Está seguro que deseas eliminar todos los sustitutos de ${state.driveSeleccionado === null ? '' : state.driveSeleccionado.Caffenio}?`}</p>}
        isActive={state.confirmModal}
        done={() => DeleteSustitutoDrive({ IdCaffenio: state.driveSeleccionado.IdCaffenio })}
        cancel={() => setState({ ...state, confirmModal: false })}
      />

    </div>
  )
}